export { default } from './MessageBubblesOutline'
